import React from 'react';
import './TopRetailer.css';

const TopRetailer = ({ Title, Address, Zipcode, Id, homeDelivery, routeOnPage }) => {
    return (
        <div className="col-lg-4 col-md-4 col-sm-12 mr-1 mb-3 topSkills topSkills__contentDisplay" key={Id}
            onClick={routeOnPage}>
            <div className="card card__retailer">
                <div className="card-body d-flex flex-column topSkills__content">
                    <h5 className="card-title topSkills__title">{Title}</h5>
                    <p className="card-title topSkills__title">{Address}{Zipcode ? `, ${Zipcode}` : ''}</p>
                    <h6 className="card-title home__delivery">{homeDelivery == "Yes" ? "Home Delivery Services Available" : ""}</h6>
                </div>
            </div>
        </div>
    )
}

export default TopRetailer
